import { render, staticRenderFns } from "./PostingDetailsV2.vue?vue&type=template&id=cdd1774c&scoped=true"
import script from "./PostingDetailsV2.vue?vue&type=script&lang=ts"
export * from "./PostingDetailsV2.vue?vue&type=script&lang=ts"
import style0 from "./PostingDetailsV2.vue?vue&type=style&index=0&id=cdd1774c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd1774c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdd1774c')) {
      api.createRecord('cdd1774c', component.options)
    } else {
      api.reload('cdd1774c', component.options)
    }
    module.hot.accept("./PostingDetailsV2.vue?vue&type=template&id=cdd1774c&scoped=true", function () {
      api.rerender('cdd1774c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recruiting/postingDetails/PostingDetailsV2.vue"
export default component.exports